import type { CityConfig } from "@/pages/city-template/types";

export const bristolConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Bristol",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "bristol",
  route: "/bristol",
  title: "Emergency & Expedited Passport Services Bristol TN | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Bristol, TN — as fast as 24 hours. No Bristol passport agency. Fast Passport Center couriers to the Atlanta Passport Agency at 805 Broadway, about 290 miles west. A+ BBB rated. Serving Tri-Cities families, Bristol Motor Speedway visitors, and the birthplace of country music.",
  h1: "Emergency & Expedited Passport Services in Bristol, TN",
  heroSubtitle: "Bristol straddles the Tennessee-Virginia border in the Tri-Cities region — the birthplace of country music and home to the iconic Bristol Motor Speedway. Fast Passport Center's registered couriers deliver your documents to the Atlanta Passport Agency at 805 Broadway so you get a new or renewed passport as fast as 24 hours — whether you're a NASCAR crew member heading to international races, a King University student studying abroad, or a Bristol family planning a trip to Canada.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Bristol%20Tennessee%20and%20Virginia%20historic%20downtown%20State%20Street%20with%20the%20iconic%20Bristol%20sign%20spanning%20the%20state%20line%20at%20golden%20hour%2C%20classic%20Appalachian%20small%20city%20architecture%20with%20vintage%20brick%20buildings%20and%20mountain%20backdrop%2C%20warm%20sunlight%20on%20the%20birthplace%20of%20country%20music%20streetscape%2C%20professional%20wide%20angle%20photography&width=1800&height=700&seq=bristol-tn-hero-001&orientation=landscape",
  heroImageAlt: "Bristol Tennessee with historic State Street and the iconic Bristol sign spanning the TN-VA state line",
  geoPosition: "36.5951;-82.1887",
  geoPlacename: "Bristol, Tennessee",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 290 miles from Bristol — about 4 hours 30 minutes via I-81 and I-75",
  },
  nearbyCitiesZips: [
    { name: "Bristol", zips: "37620, 37621" },
    { name: "Kingsport", zips: "37660, 37663, 37664, 37665" },
    { name: "Johnson City", zips: "37601, 37604, 37614, 37615" },
    { name: "Abingdon", zips: "24210, 24211, 24212" },
    { name: "Blountville", zips: "37617" },
    { name: "Bluff City", zips: "37618" },
    { name: "Elizabethton", zips: "37643" },
    { name: "Piney Flats", zips: "37686" },
    { name: "Lebanon", zips: "24266" },
    { name: "Gate City", zips: "24251" },
    { name: "Marion", zips: "24354" },
    { name: "Greeneville", zips: "37743, 37744, 37745" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Atlanta Passport Agency — 290 miles, but overnight courier handles the distance" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Tri-Cities Hub", desc: "Serving Bristol, Kingsport, Johnson City, and all Northeast Tennessee" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Bristol case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Nashville TN", route: "/nashville" },
    { name: "Expedited passport in Kingsport TN", route: "/kingsport" },
    { name: "Urgent passport in Johnson City TN", route: "/johnson-city" },
    { name: "Tennessee passport hub", route: "/tennessee" },
    { name: "Fast passport in Knoxville TN", route: "/knoxville" },
  ],
  fpcOfficeAddress: "805 Broadway, Nashville, TN 37203",
  fpcOfficeNote: "Fast Passport Center serves Bristol remotely via secure courier. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency at 805 Broadway — approximately 290 miles west. Bristol is the farthest Tennessee city from the Atlanta Passport Agency, making our courier service especially valuable for Northeast Tennessee travelers who would otherwise face a 9-hour round trip drive through the Appalachians.",
  fpcOfficeDistance: "Serving all of Northeast Tennessee including the TN-VA border region",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Bristol, Kingsport, Johnson City, Abingdon, and the greater Tri-Cities region. From NASCAR crew members traveling to international races to King University students heading abroad, we help Northeast Tennessee and Southwest Virginia travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Bristol and nearby communities including Kingsport, Johnson City, Abingdon VA, Blountville, Bluff City, Elizabethton, and the entire Tri-Cities area.",
  howItWorksIntro: "Most Bristol travelers complete everything online and ship documents overnight. At 290 miles from Nashville — the farthest TN city from the agency — Fast Passport Center's courier service eliminates the 9-hour round trip drive through the Appalachian Mountains.",
  mistakesIntro: "Bristol travelers, including NASCAR crew members heading to international races and King University students studying abroad, face unique passport challenges given Bristol's TN-VA border location and distance from the Atlanta Passport Agency. Here are the most common mistakes we see.",
  testimonialsIntro: "Bristol and Tri-Cities travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Bristol? Here are the most common ones we hear from Tri-Cities and Northeast Tennessee travelers.",
  servicesIntro: "Whether you need an emergency passport for a NASCAR international race, a renewal before a TRI connection to Europe, or a first-time passport for a King University study abroad student — Fast Passport Center handles it with reserved courier submission availability, bridging Bristol's 290-mile distance from the Atlanta Passport Agency. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  dmvWebsite: "https://www.tn.gov/safety/driver-services.html",
  dmvLabel: "Tennessee Department of Safety — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No drive or appointment needed — saves 9 hours round trip", "Ideal for NASCAR crew members traveling internationally", "Perfect for King University study abroad students", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service USPS", "Good for planned travel from TRI or connecting through CLT", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "No document review — errors cause rejection", "In-person clerk appointment required", "Workload shifts with government shutdowns", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins at 805 Broadway", "Life-or-death emergencies only", "290 miles to Nashville (4.5-hour drive via I-81/I-40)", "Longest in-state drive to any TN passport agency"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Bristol is 290 miles from Nashville — our courier saves Northeast Tennessee travelers a 9-hour round trip Appalachian drive.",
      bullets: ["Northeast TN coverage", "24–48 hour turnaround available", "No 9-hour round trip to Nashville needed"],
      badge: "Saves 9-Hour Drive",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Bristol adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Bristol and Sullivan County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Bristol and Sullivan County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Bristol, Kingsport, and Tri-Cities residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Nashville agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Sullivan County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Bristol and Tri-Cities residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for international NASCAR race seasons? Bristol crew members and Tri-Cities business travelers often require a second passport while one is held for visa processing.",
      bullets: ["Ideal for NASCAR crew international travel", "Use while primary passport is in visa processing", "Full 10-year validity"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Water-damaged or worn passports from frequent travel are not valid. We replace damaged passports quickly for Bristol and Northeast Tennessee residents.",
      bullets: ["DS-11 replacement for damaged books", "Document condition review", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size passport card for land and sea crossings to Canada — especially practical for Bristol's proximity to the Canadian border via the Northeast corridor.",
      bullets: ["Valid for land and sea travel only", "Fits in your wallet — convenient carry", "Less expensive than a passport book"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Bristol TN", description: "Urgent passport processing for Bristol, TN travelers via Atlanta Passport Agency courier — 290 miles from Bristol." },
    { name: "Passport Renewal Bristol TN", description: "Fast passport renewal for Bristol and Sullivan County, Tennessee residents." },
    { name: "New Passport Bristol TN", description: "First-time passport application assistance for Bristol and Tri-Cities area residents." },
    { name: "Lost Passport Bristol TN", description: "Passport replacement for lost or stolen passports for Bristol and Northeast Tennessee residents." },
    { name: "Child Passport Bristol TN", description: "Minor passport services for Bristol and Sullivan County families." },
    { name: "Name Change Passport Bristol TN", description: "Passport name change service for Bristol, TN residents." },
  ],
  testimonials: [
    {
      name: "Danny T.",
      location: "NASCAR Crew Member",
      rating: 5,
      text: "I'm on a NASCAR Cup Series pit crew and got a last-minute call for a test session at a track in England — 5 days before departure. My passport had expired. Fast Passport Center had me a new passport in 48 hours. Being 290 miles from Nashville, there's no way I could've driven there and back.",
      service: "Emergency Passport",
    },
    {
      name: "Samantha K.",
      location: "King University Student",
      rating: 5,
      text: "King University nursing student accepted to a summer program in Costa Rica. Had 12 days before the flight and no passport. Fast Passport Center got everything handled in 5 business days. They made a first-time application feel totally stress-free.",
      service: "First-Time Passport",
    },
    {
      name: "The Carter Family",
      location: "Bristol, TN",
      rating: 5,
      text: "Bristol family of four planning a trip to Niagara Falls and Toronto. Two adult renewals and two first-time child passports. Fast Passport Center managed the whole family order and had all four passports delivered in 8 business days. The personal agent kept us updated every step.",
      service: "Family Passport Package",
    },
    {
      name: "Linda W.",
      location: "Abingdon, VA",
      rating: 5,
      text: "Abingdon resident who planned a retirement trip to Scotland. Realized 3 weeks out my passport was expired. Fast Passport Center expedited my renewal and had it back in 7 business days. They even handled the cross-state shipping perfectly.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "bri-1",
      name: "Bristol Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 6th St",
      city: "Bristol",
      state: "TN",
      zip: "37620",
      phone: "(423) 968-3111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bristol — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Bristol and Sullivan County residents. Located in downtown Bristol near State Street. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "bri-2",
      name: "Sullivan County Clerk Office — Bristol",
      type: "County Clerk Passport Acceptance",
      address: "801 Anderson St",
      city: "Bristol",
      state: "TN",
      zip: "37620",
      phone: "(423) 989-4488",
      hours: "Mon–Fri: 8:30 AM – 5:00 PM",
      distance: "Bristol — Downtown",
      website: "https://www.sullivancountytn.gov",
      websiteLabel: "Sullivan County Government",
      notes: "County clerk passport acceptance in the Bristol satellite office. Convenient downtown alternative to the post office.",
      icon: "ri-government-line",
    },
    {
      id: "bri-3",
      name: "Kingsport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1001 N Eastman Rd",
      city: "Kingsport",
      state: "TN",
      zip: "37660",
      phone: "(423) 245-5942",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kingsport — 22 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Kingsport and western Bristol area residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "bri-4",
      name: "Johnson City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "311 E Main St",
      city: "Johnson City",
      state: "TN",
      zip: "37601",
      phone: "(423) 928-0165",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Johnson City — 25 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnson City and Washington County. Convenient for southern Bristol area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bri-5",
      name: "Abingdon Post Office — Virginia",
      type: "USPS Passport Acceptance Facility",
      address: "300 W Main St",
      city: "Abingdon",
      state: "VA",
      zip: "24210",
      phone: "(276) 628-5131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Abingdon — 15 miles northeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Bristol residents near the Virginia state line. Washington County VA passport acceptance facility.",
      icon: "ri-mail-line",
    },
    {
      id: "bri-6",
      name: "Sullivan County Clerk — Blountville",
      type: "County Clerk Passport Acceptance",
      address: "3411 Highway 126",
      city: "Blountville",
      state: "TN",
      zip: "37617",
      phone: "(423) 323-6444",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Blountville — 10 miles west",
      website: "https://www.sullivancountytn.gov",
      websiteLabel: "Sullivan County Government",
      notes: "Main Sullivan County Clerk office in Blountville. Full passport acceptance services available.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Agency", agency: "290 miles — 4.5-hour drive to Atlanta via I-81/I-75, plus appointment required", fpc: "We drive for you — no appointment needed, saves 9-hour round trip" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Best Price Guarantee", agency: "No — government fees only", fpc: "Yes — 30-100% less than resellers" },
    { feature: "Local Expertise", agency: "Generic — no local knowledge", fpc: "Yes — Tri-Cities travel patterns and guidance" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Headed to the Wrong State for Passport Services",
      description: "Bristol residents on State Street can literally stand in two states at once — but that doesn't mean you can use both states' passport facilities. Your passport application must be processed based on your legal residence address. Tennessee residents must use Tennessee acceptance facilities and the Nashville agency.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the 290-Mile Nashville Drive",
      description: "At 290 miles, Bristol is the farthest Tennessee city from the Atlanta Passport Agency — a 9-hour round trip through the Appalachian Mountains on I-81 and I-40. Even if you secure an NPIC appointment, that's a full day of driving. Fast Passport Center's courier service eliminates this entirely.",
    },
    {
      icon: "ri-global-line",
      title: "NASCAR Crew Members Forgetting International Work Visa Requirements",
      description: "NASCAR crew members heading to international races (like the NASCAR Whelen Euro Series) often focus on the passport and forget work/visitor visa requirements. The UK and European Union countries may require specific documentation for motorsports professionals beyond a tourist passport.",
    },
    {
      icon: "ri-calendar-line",
      title: "Scheduling During Bristol Motor Speedway Race Weeks",
      description: "Bristol Motor Speedway race weeks bring 150,000+ visitors to town. Post office lines swell and local acceptance facility appointments become scarce. Plan passport applications well outside major race weeks.",
    },
    {
      icon: "ri-restart-line",
      title: "TN-VA Border Confusion With Mailing Addresses",
      description: "Bristol residents who receive mail at a Virginia address but legally reside in Tennessee (or vice versa) create confusion with passport applications. Your passport will list your legal state of residence — not your mailing address state.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Bristol, Kingsport, or Johnson City." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Atlanta Passport Agency — 290 miles away via overnight air courier." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Atlanta Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bristol or Tri-Cities address — fully trackable." },
  ],
  faqs: [
    { q: "How far is Bristol from the Nashville passport agency?", a: "Bristol is approximately 290 miles from the Atlanta Passport Agency at 805 Broadway — about a 4.5-hour drive west via I-81 and I-40 through the Appalachian Mountains. Bristol is the farthest Tennessee city from the Nashville agency." },
    { q: "Does Bristol, TN have its own passport agency?", a: "No. Bristol does not have a passport agency. The closest passport agency is the Atlanta Passport Agency at 805 Broadway, about 290 miles west." },
    { q: "I live on State Street — which state do I apply in?", a: "Bristol's State Street literally marks the Tennessee-Virginia state line. Your passport application must be filed according to your legal residence address — not which side of State Street you're standing on." },
    { q: "Where do Bristol travelers typically fly internationally?", a: "Bristol travelers typically use Tri-Cities Airport (TRI, about 20 miles southwest) for domestic connections, then connect through Charlotte Douglas (CLT), Atlanta (ATL), or Nashville (BNA) for international flights." },
    { q: "I'm a NASCAR crew member — how fast can I get a passport for international races?", a: "NASCAR crew members traveling to international series like the Whelen Euro Series are among our most time-sensitive clients. Emergency processing delivers passports in 24–48 hours. Standard expedited processing runs 2–9 business days." },
    { q: "How fast can I get an emergency passport in Bristol?", a: "Emergency processing is typically 24–48 hours for Bristol residents. Despite being 290 miles from Nashville, our overnight air courier routing ensures documents arrive at the Atlanta Passport Agency by the next business morning." },
    { q: "Where can I get passport photos in Bristol?", a: "Walgreens at 1140 Volunteer Pkwy and CVS at 1410 Volunteer Pkwy in Bristol both offer passport photo services. UPS Store locations in Bristol and Kingsport also provide photo services." },
    { q: "Can the Sullivan County Clerk's office process my passport?", a: "Yes. Both the Sullivan County Clerk's office in Bristol at 801 Anderson St and the main Blountville office at 3411 Highway 126 accept passport applications. Call ahead to confirm current hours." },
    { q: "How do I renew my passport in Bristol?", a: "Adult renewals meeting DS-82 eligibility criteria can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — saving Bristol residents the 9-hour round trip drive to Nashville." },
    { q: "Can Bristol, VA residents use your service?", a: "Yes. While Bristol straddles the TN-VA state line, we serve residents throughout the Tri-Cities region including both Bristol, TN and Bristol, VA as well as Abingdon, Gate City, and surrounding Southwest Virginia communities." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Bristol Residents",
    intro: "Bristol's position as the farthest Tennessee city from any passport agency — combined with its unique TN-VA border location, NASCAR international racing schedule, and Tri-Cities regional economy — creates one of the most distinctive passport landscapes in the state. Here's what Bristol travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "TRI — Tri-Cities Airport",
        subtitle: "Regional airport serving Bristol, Kingsport, and Johnson City",
        description: "Tri-Cities Airport (TRI) in Blountville is the primary airport for the entire Tri-Cities region, about 20 miles southwest of Bristol. TRI offers daily flights to major hubs — Atlanta (Delta), Charlotte (American), and Dallas (DFW) — providing reliable connections to international gateways. The airport's small size means short security lines and easy parking, but zero international passenger service means every international trip requires a connection. Passport validity is verified at TRI check-in for the full itinerary.",
        tip: "TRI connections through Charlotte (CLT) are the most common international routing for Bristol travelers. American Airlines' CLT hub is just a 45-minute flight from TRI. Make sure your passport is valid before arriving at TRI — you will not make it to Charlotte otherwise.",
      },
      {
        icon: "ri-steering-line",
        title: "Bristol Motor Speedway & NASCAR International Travel",
        subtitle: "The Last Great Colosseum, 150,000+ capacity, global racing audience",
        description: "Bristol Motor Speedway is one of the most iconic venues in motorsports, hosting two NASCAR Cup Series weekends annually that draw 150,000+ fans. The speedway's international reach creates two distinct passport patterns: NASCAR crew members and teams traveling to international series (Whelen Euro Series in the UK and Europe, Pinty's Series in Canada, Mexico Series), and international media, sponsors, and officials traveling to Bristol for race weekends. Crew members often get international race assignments on 5–10 days notice.",
        tip: "NASCAR crew members traveling internationally should maintain a second passport. International race assignments often require visa processing for the destination country (UK, Germany, Canada) — during which the primary passport is unavailable. A second passport ensures you can still travel if another international opportunity arises.",
      },
      {
        icon: "ri-music-line",
        title: "Birthplace of Country Music & Heritage Tourism",
        subtitle: "1927 Bristol Sessions, Birthplace of Country Music Museum, global music tourism",
        description: "The 1927 Bristol Sessions — known as the 'Big Bang of Country Music' — forever changed American music. Today, the Birthplace of Country Music Museum and the annual Bristol Rhythm & Roots Reunion festival draw international visitors from the UK, Australia, Japan, and across Europe. This heritage tourism creates two passport flows: international visitors extending their U.S. trip who discover passport issues while in East Tennessee, and Bristol music professionals traveling to international folk, roots, and Americana festivals in the UK, Ireland, Australia, and continental Europe.",
        tip: "Bristol musicians and festival organizers traveling to international events (Celtic Connections in Glasgow, AmericanaFest UK in London, Out on the Weekend in Australia) often book 6–12 months ahead. Check passport validity at booking — not a month before departure.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "King University & Tri-Cities Academic Travel",
        subtitle: "King University, ETSU, Milligan, Northeast State",
        description: "King University in Bristol and East Tennessee State University in Johnson City generate significant academic international travel. King University nursing students travel to Costa Rica, Guatemala, and the Dominican Republic for clinical rotations. ETSU's medical school sends residents to international rotations. Study abroad programs at both institutions run on 8–12 week acceptance-to-departure pipelines. Additionally, the Tri-Cities' growing healthcare sector sends medical professionals to international conferences.",
        tip: "King University and ETSU students accepted to study abroad programs should apply for passports immediately upon acceptance. The 6–10 week window between acceptance and departure is tight for standard processing but comfortable for expedited courier service.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Bristol & the 290-Mile Reality",
      description: "At 290 miles from Nashville, Bristol is the farthest Tennessee city from the state's only passport agency. A self-drive Nashville agency appointment is a 9-hour round trip — essentially a full day lost. Our overnight air courier service eliminates this distance entirely, ensuring Bristol travelers get the same fast turnaround as Nashville residents despite the 290-mile gap.",
    },
  },
  destinations: {
    title: "Where Bristol Travelers Go — And Why Passports Get Urgent",
    intro: "The Tri-Cities' motorsports, music heritage, and academic ecosystem sends travelers worldwide. Here are the most common international destinations and urgency patterns.",
    stats: [
      { stat: "290 Miles", label: "from Bristol to the Atlanta Passport Agency — farthest TN city from the only in-state agency" },
      { stat: "5–10 Days", label: "average notice for NASCAR crew members called to international race assignments" },
      { stat: "Aug–Sep", label: "peak season when Bristol Night Race, fall semester study abroad, and music festival season collide" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a Bristol NASCAR crew member departing to England" },
    ],
    destinations: [
      { name: "United Kingdom", context: "NASCAR Whelen Euro Series races at Brands Hatch, country music heritage tours, King University exchange programs", urgency: "Race assignments 5–10 days out; music festival bookings 3–6 months ahead", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "NASCAR Pinty's Series events, Tri-Cities family trips to Toronto and Niagara Falls, ETSU academic partnerships", urgency: "Race crew travel 1–2 weeks out; family trips booked 4–8 weeks ahead", icon: "ri-map-pin-2-line" },
      { name: "Germany & Austria", context: "NASCAR Whelen Euro Series at Hockenheimring and Salzburgring, country music festivals, automotive supplier visits", urgency: "European race assignments booked 2–3 weeks out; Schengen visa-free for U.S. citizens", icon: "ri-map-pin-2-line" },
      { name: "Costa Rica & Dominican Republic", context: "King University nursing clinical rotations, ETSU medical mission trips, family vacation packages", urgency: "Clinical rotations confirmed 4–8 weeks before departure; some require student visas", icon: "ri-map-pin-2-line" },
      { name: "Mexico", context: "NASCAR Mexico Series events, Tri-Cities family resort vacations, mission trips from area churches", urgency: "Spring break and summer bookings peak January through April", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Country music touring circuit, Americana music festivals, outdoor adventure guiding exchanges", urgency: "Long-haul tour routing requires passport valid 6+ months; visa processing 4–6 weeks", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Tennessee Service Areas",
    crossLinksDesc: "We serve travelers across the Volunteer State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Nashville", route: "/nashville" },
      { name: "Knoxville", route: "/knoxville" },
      { name: "Memphis", route: "/memphis" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Bristol", address: "1140 Volunteer Pkwy, Bristol, TN 37620", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Bristol", address: "1410 Volunteer Pkwy, Bristol, TN 37620", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Bristol", address: "3175 Linden Dr, Ste 102, Bristol, VA 24202", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart Photo — Bristol", address: "220 Century Blvd, Bristol, TN 37620", hours: "Mon–Sun: 7AM–9PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    { name: "TN Driver Services — Kingsport", address: "4728 Lake Park Dr, Kingsport, TN 37664", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Closest full Driver Services Center to Bristol. REAL ID, driver's license, and state ID services for Sullivan County residents.", featured: true },
    { name: "TN Driver Services — Johnson City", address: "4717 Lake Park Dr, Johnson City, TN 37615", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Washington County and southern Tri-Cities. REAL ID processing available.", featured: false },
    { name: "VA DMV — Abingdon", address: "255 W Main St, Abingdon, VA 24210", hours: "Mon–Fri: 8:00AM–5:00PM, Sat: 8:00AM–12:00PM", note: "Virginia DMV for Bristol VA residents and Washington County. Saturday hours available.", featured: false },
  ],
  airports: [
    {
      code: "TRI",
      name: "Tri-Cities Airport",
      distance: "20 miles southwest of Bristol",
      address: "2525 TN-75, Blountville, TN 37617",
      note: "Closest airport to Bristol with daily flights to major hubs including Atlanta (ATL), Charlotte (CLT), and Dallas (DFW). About 25 minutes via I-81. Primary gateway for Tri-Cities international connections.",
      flightUrl: "https://triflight.com/",
      flightLabel: "TRI Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "175 miles southeast of Bristol",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub and common connecting point for Bristol travelers. About 3 hours via I-77 and I-81. Extensive domestic and international routes worldwide.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "290 miles west of Bristol",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Tennessee's busiest airport co-located with the Atlanta Passport Agency. About 4.5 hours via I-81 and I-40.",
      flightUrl: "https://flynashville.com/",
      flightLabel: "BNA Airport",
      featured: false,
    },
    {
      code: "TYS",
      name: "McGhee Tyson Airport",
      distance: "110 miles southwest of Bristol",
      address: "2055 Alcoa Hwy, Alcoa, TN 37701",
      note: "Knoxville's airport with domestic routes. About 2 hours via I-81 and I-40. Alternative for Tri-Cities travelers heading south.",
      flightUrl: "https://flyknoxville.com/",
      flightLabel: "TYS Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Tennessee Department of Health Vital Records office. Online and mail options available for Sullivan County.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records.html",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Tennessee Vital Records. Required for estate and legal matters in Sullivan County.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records.html",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Sullivan County Clerk. Certified copies available for name changes and passport applications.",
      url: "https://www.sullivancountytn.gov/241/Clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Sullivan County Circuit Court Clerk. Required for name change passport corrections.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/divorce.html",
    },
  ],
};